import { Icon } from './types';

export const Planet = ({ svgProps, pathProps }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="57"
    viewBox="0 0 57 57"
    fill="none"
    data-testid="planet"
    {...svgProps}
  >
    <path
      fill="currentColor"
      d="M28.333 0C12.693 0 0 12.693 0 28.333c0 15.64 12.693 28.334 28.333 28.334 15.64 0 28.334-12.694 28.334-28.334C56.667 12.693 43.973 0 28.333 0ZM5.667 28.333c0-1.728.226-3.428.595-5.043l13.543 13.543v2.834c0 3.116 2.55 5.666 5.667 5.666v5.469C14.337 49.385 5.667 39.865 5.667 28.333Zm39.355 15.3c-.737-2.295-2.834-3.966-5.384-3.966h-2.833v-8.5a2.842 2.842 0 0 0-2.833-2.834h-17v-5.666h5.666a2.842 2.842 0 0 0 2.834-2.834v-5.666h5.666c3.117 0 5.667-2.55 5.667-5.667V7.338C45.107 10.682 51 18.842 51 28.333c0 5.894-2.295 11.277-5.978 15.3Z"
      {...pathProps}
    />
  </svg>
);
